import * as React from 'react';
const carouselNavIndexContext = React.createContext(undefined);
export const carouselNavIndexContextDefaultValue = 0;
export const useCarouselNavIndexContext = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(carouselNavIndexContext)) !== null && _React_useContext !== void 0 ? _React_useContext : carouselNavIndexContextDefaultValue;
};
export const CarouselNavIndexContextProvider = carouselNavIndexContext.Provider;
